import user from './user'
import printer from './printer'
export default {
    user,
    printer
}
